import React from 'react';
import { formatCurrency, formatWon, formatNumber } from '../../../utils/currency';
import { useAuth } from '../../../contexts/AuthContext';
import { useTranslation } from '../../../utils/i18n';
import './StepStyles.css';

const Step3Amount = ({ formData, setFormData }) => {
  const { language } = useAuth();
  const { t } = useTranslation(language);
  // Quick amounts in KRW (Korean Won)
  const quickAmounts = [
    1000000, 5000000, 10000000, 20000000, 50000000, 100000000,
  ];

  const handleAmountChange = (e) => {
    const value = e.target.value.replace(/[^0-9]/g, '');
    setFormData((prev) => ({
      ...prev,
      amount: parseInt(value) || 0,
    }));
  };

  const handleQuickSelect = (amount) => {
    setFormData((prev) => ({
      ...prev,
      amount,
    }));
  };

  return (
    <div className="step-container">
      <div className="form-group">
        <label className="form-label">
          {t('loanAmountInput')} <span className="required">*</span>
        </label>
        <div className="amount-input-wrapper">
          <input
            type="text"
            value={formData.amount ? formatNumber(formData.amount) : ''}
            onChange={handleAmountChange}
            placeholder="0"
            className="amount-input"
          />
          <span className="amount-suffix">₩ (Won)</span>
        </div>
      </div>

      {/* <div className="quick-select">
        <p className="quick-select-label">{t('quickSelect')}:</p>
        <div className="quick-buttons">
          {quickAmounts.map((amount) => (
            <button
              key={amount}
              type="button"
              className={`quick-btn ${formData.amount === amount ? 'active' : ''}`}
              onClick={() => handleQuickSelect(amount)}
            >
              {amount >= 1000000
                ? `${amount / 1000000}${t('million')}`
                : formatWon(amount, '원')}
            </button>
          ))}
        </div>
      </div> */}

      {(!formData.amount || formData.amount < 500000) && (
        <div className="step-info warning">
          ⚠️ {t('minimumLoan')}: ₩500,000
        </div>
      )}
    </div>
  );
};

export default Step3Amount;
